module.exports = {
	"button.label.read_more": "Lue lisää",
	"button.label.read_less": "Lue vähemmän"
};


//////////////////
// WEBPACK FOOTER
// ../resources/strings/fi_FI.json
// module id = 659
// module chunks = 0